import { render } from "./VSkeleton.vue?vue&type=template&id=4b698e07"
const script = {}

import "./VSkeleton.vue?vue&type=style&index=0&id=4b698e07&lang=sass"

import exportComponent from "/home/gitlab-runner/builds/dhPKyzHk/0/den59k/reply200-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__